import BaseEvaluator from './BaseEvaluator';

export default class BooleanEvaluator extends BaseEvaluator {
  constructor(fieldName, friendlyFieldName, model, mutator = null) {
    super(fieldName, friendlyFieldName, model, mutator);
    this.evaluatorName = 'boolean';
  }

  validate() {
    if (this.value === null || this.value === '') {
      // Allow blank
      this.isValid = true;
    } else if (
      this.value === 'true' ||
      this.value === 'false' ||
      typeof this.value === 'boolean' ||
      parseInt(`${this.value}`, 10) === 0 ||
      parseInt(`${this.value}`, 10) === 1
    ) {
      this.isValid = true;
    } else {
      this.isValid = false;
    }
    return this.isValid;
  }
}
